MessageFormat.locale.es=function(n){return n===1?"one":"other"}
